export class Marca{
    public constructor(
        public id: String = "",
        public nombre: String = "",
        public empresa_id: String = "",
        public usuario_id:String = null
    ){
        //
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/marca.ts